var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7659 2.84099C28.6795 3.32295 27.5116 3.64854 26.2862 3.79502C27.537 3.0452 28.4978 1.85787 28.9501 0.442984C27.7793 1.13743 26.4827 1.64154 25.1025 1.91324C23.9974 0.735644 22.4228 0 20.6801 0C17.3341 0 14.6211 2.71267 14.6211 6.05866C14.6211 6.53353 14.6747 6.99601 14.7781 7.43943C9.74259 7.18679 5.27822 4.7746 2.28986 1.10893C1.76833 2.00375 1.46946 3.04447 1.46946 4.15487C1.46946 6.25697 2.53911 8.11143 4.16485 9.19792C3.17169 9.16647 2.23744 8.89389 1.42058 8.44013C1.41989 8.46538 1.4199 8.49077 1.4199 8.51632C1.4199 11.4518 3.50841 13.9005 6.28014 14.4574C5.77175 14.5959 5.23648 14.6699 4.68393 14.6699C4.29352 14.6699 3.91403 14.6318 3.544 14.5612C4.31508 16.9683 6.55258 18.72 9.20397 18.7687C7.13037 20.3938 4.51796 21.3625 1.67919 21.3625C1.19014 21.3625 0.707878 21.3337 0.233887 21.2777C2.91525 22.9969 6.1 24 9.52158 24C20.666 24 26.7604 14.7678 26.7604 6.76108C26.7604 6.49839 26.7544 6.23718 26.7428 5.97715C27.9264 5.12308 28.9536 4.05608 29.7658 2.84099H29.7659Z",
    fill: "#F8F7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5321,
    height: 24,
    fill: "white",
    transform: "translate(0.233887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d2a4258211af0674f3348fab251ece19.svg";
export { ForwardRef as ReactComponent };